<template>
<div id="films">
    <div class="container">
        <ul class="row cards">
            <li class="col-sm-12 card" v-for="film in films" v-bind:key="film.id" @click='handleFold(film)'>
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 col-md-4" id="cover">
                            <div class="cover" :style="bgcss(film.cover)">
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-8" id="book-des">
                            <h2> {{film.name}} </h2>
                            <h4> {{film.author}} </h4>
                            <div>
                                <div class='containerb' :class="film.fold ? 'fold' : 'unfold'"   v-html="film.description"></div>
                                <span class="down"  v-show="film.fold"><i class="fas fa-angle-down"></i></span>
                                <span class="down"  v-show="!film.fold"><i class="fas fa-angle-up"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>
</template>
<script >
import axios from "axios";
export default({
    name: 'films',
    data() {
        return {
            films: []
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            axios.get('static/films.json').then(response => {
                this.films=response.data.films
                console.log(response.data);
            }, response => {
                console.log("error");
            });
            
        },
        bgcss(url){
            return {'background-image': 'url('+url+')',
                    'background-size': 'cover',
                    'background-position': 'center center'}
        },
        handleFold(film) {
            console.log(film.fold);
            film.fold = !film.fold;
            console.log(film.fold);
            
        }
    },
});

</script>

<style>

#films span{
    padding: 20px 100px 0px 100px;
}


</style>


// WEBPACK FOOTER //
// src/components/pages/information/films.vue